window.assistHelper = (function () {

	var isInteractiveChartAppTabPage = function () {
		// verify if interactive chart is a tab page or an menu page
		var tabPage = $('#main .tab-content #tab-chart #charting .f2-app-container.com_wfebrokerage_desktop_interactivechart');

		// tab page
		if (tabPage.length > 0) {
			return true;
		}

		return false;
	};

	return {
		isInteractiveChartAppTabPage: isInteractiveChartAppTabPage
	};
})();
